import * as React from "react";
import { Route, RouteProps, Redirect } from "react-router-dom";
import { UserContext } from "../context/UserContext";
import { Roles } from "../constants/Roles";

interface PrivateRouteProps extends RouteProps {
  component?: any;
  roles?: Array<string>;
  componentProps?: any;
}

const PrivateRoute = (props: PrivateRouteProps) => {
  const user = React.useContext(UserContext);
  const { component: Component, ...rest } = props;
  let componentProps = {};
  if (props.componentProps) componentProps = props.componentProps;

  function userHasAccess() {
    if (props.roles) {
      let hasAccess = false;
      for (let role of props.roles) {
        switch (role) {
          case Roles.Admin:
            hasAccess = hasAccess || user.attributes.companyAdmin;
            break;
          case Roles.HR:
            hasAccess = hasAccess || user.attributes.hr;
            break;
          case Roles.Clerical:
            hasAccess = hasAccess || user.attributes.clerical;
            break;
        }
      }
      return hasAccess;
    } else {
      return true;
    }
  }

  return (
    <Route
      {...rest}
      render={(routeProps) => {
        if (!user.authenticated) {
          // not logged in so redirect to login page with the return url
          return (
            <div />
            // <Redirect to={{ pathname: "/", state: { from: props.location } }} />
          );
        }

        // check if route is restricted by role
        if (!userHasAccess()) {
          // role not authorised so redirect to home page
          return (
            <Redirect to={{ pathname: "/", state: { from: props.location } }} />
          );
        }

        // authorized so return component
        return <Component {...routeProps} {...componentProps} />;
      }}
    />
  );
};

export default PrivateRoute;
